import MuiTypography from '@mui/material/Typography';

export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 25,
    },
    sort: {
      by: 'name',
      direction: 'asc',
    },
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'id',
      key: 'id',
      sort_key: 'id',
      sortable: true,
      label: 'ID',
      width: 50,
    },
    {
      id: 'attributes.name',
      key: 'name',
      sort_key: 'name',
      sortable: true,
      label: 'Name',
    },
  ],
  render: {
    formatHead: (key, value) => {
      switch (key) {
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value.toUpperCase()}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick) => {
      switch (key) {
        case 'id':
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold' }}
              onClick={onClick}
            >
              {value || '-'}
            </MuiTypography>
          );

        default:
          return (
            <MuiTypography variant='body1' onClick={onClick}>
              {value || '-'}
            </MuiTypography>
          );
      }
    },
  },
};
